interface LoadingStateProps {
  message?: string;
  className?: string;
  compact?: boolean;
}

/**
 * Standardized loading state component for content areas.
 *
 * @example
 * if (isLoading) return <LoadingState message="Loading contacts..." />;
 */
export default function LoadingState({
  message = 'Loading...',
  className = '',
  compact = false,
}: LoadingStateProps) {
  return (
    <div className={`flex flex-col items-center justify-center ${compact ? 'py-6' : 'py-12'} ${className}`}>
      <div
        role="status"
        aria-label={message}
        className={`${compact ? 'h-8 w-8' : 'h-10 w-10'} animate-spin rounded-full border-4 border-theme-secondary border-t-primary-600 dark:border-t-primary-400`}
      />
      <p className="mt-3 text-sm text-theme-tertiary">
        {message}
      </p>
    </div>
  );
}
